<div class="scenes-table">
  <app-data-table
    [columns]="columns()"
    [data]="tableRows()"
    [config]="config"></app-data-table>
</div>

<ng-template #quickViewCell let-row>
  <button
    type="button"
    class="thumb"
    [title]="'EXTERNAL_SCENES.ACTION_OPEN_PREVIEW' | translate"
    (click)="previewClick.emit(row.id); $event.stopPropagation()">
    @if (row.showPreview) {
      <img
        class="thumb__image"
        loading="lazy"
        [src]="row.previewUrl"
        [alt]="row.name"
        (error)="onPreviewError(row.id)" />
      @if (row.previewFormat) {
        <span class="thumb__chip">{{ row.previewFormat }}</span>
      }
    } @else {
      <span class="thumb__empty"><i class="pi pi-image"></i></span>
    }
    <i class="pi pi-expand thumb__expand"></i>
  </button>
</ng-template>

<ng-template #sceneCell let-row>
  <div class="scene">
    <span class="scene__name" [title]="row.name">{{ row.name }}</span>
    @if (row.coordinatesLabel) {
      <span class="scene__coordinates">{{ row.coordinatesLabel }}</span>
    }
  </div>
</ng-template>

<ng-template #sourceCell let-row>
  <span class="provider {{ row.providerClass }}">{{ row.providerLabelKey | translate }}</span>
</ng-template>

<ng-template #dateCloudCell let-row>
  <div class="date-cloud">
    <span>{{ row.acquiredAt | date: 'dd.MM.yyyy' }}</span>
    @if (row.cloudCoverLabel) {
      <span class="date-cloud__cloud">{{ row.cloudCoverLabel }}</span>
    }
  </div>
</ng-template>

<ng-template #sizeCell let-row>
  <span>{{ row.sizeLabel || '—' }}</span>
</ng-template>

<ng-template #etaCell let-row>
  @if (row.etaMinutes !== null) {
    <div class="eta">
      <span>{{ 'EXTERNAL_SCENES.ETA_MINUTES' | translate: { minutes: row.etaMinutes } }}</span>
      <span class="eta__note">{{ 'EXTERNAL_SCENES.ETA_SPEED_NOTE' | translate: { speed: downloadSpeed } }}</span>
    </div>
  } @else {
    <span>—</span>
  }
</ng-template>

<ng-template #statusCell let-row>
  <div class="status">
    <span class="status__label">
      <span class="status__dot status__dot--{{ row.statusTone }}"></span>
      {{ row.statusKey | translate }}
    </span>
    @if (row.errorKey) {
      <span class="status__error" role="alert">{{ row.errorKey | translate }}</span>
    }
  </div>
</ng-template>

<ng-template #actionCell let-row>
  <app-table-actions [row]="row" [actions]="row.actions" (customAction)="onRowAction($event)"></app-table-actions>
</ng-template>
